module.exports = __webpack_public_path__ + "img/MH.aa0f484f.svg";